import { GlobalRoutes } from '#lib/features/navigation/constants/global-routes.js';
import type { GlobalNavLink } from '$global/features/navigation/types';

export const GlobalLinks: GlobalNavLink[] = [
	{
		label: 'Artworks',
		href: GlobalRoutes.ArtworksHome,
		isLiveDrops: true,
	},
	{
		label: 'Artists',
		href: GlobalRoutes.ArtistsHome,
	},
	{
		label: 'Shop',
		href: GlobalRoutes.ShopHome,
	},
	{
		label: 'Media',
		items: [
			{
				label: 'Art News',
				href: GlobalRoutes.NewsHome,
			},
			{
				label: 'Talks',
				href: GlobalRoutes.TalksHome,
			},
			{
				label: 'Podcasts',
				href: GlobalRoutes.PodcastsHome,
			},
		],
	},
	{
		label: 'More',
		items: [
			{
				label: 'Editions',
				href: GlobalRoutes.EditionsHome,
			},
			{
				label: 'Primary',
				href: GlobalRoutes.PrimaryHome,
			},
			{
				label: 'Private Sales',
				href: GlobalRoutes.PrivateSalesHome,
			},
			{
				label: 'NFTs',
				href: GlobalRoutes.NftHome,
			},
			{
				label: 'Exhibitions',
				href: GlobalRoutes.ExhibitionsHome,
			},
			{
				label: 'Publishing',
				href: GlobalRoutes.PublishingHome,
			},
			{
				label: 'Digital',
				href: GlobalRoutes.DigitalHome,
			},
			{
				label: 'Fabrication',
				href: GlobalRoutes.FabHome,
			},
			{
				label: 'Leviathan',
				href: GlobalRoutes.LeviathanHome,
				newTab: true,
			},
			{
				label: 'Help Centre',
				href: GlobalRoutes.FaqHome,
			},
		],
	},
];

/**
 * Destinations that are reachable from the footer sitemap but deliberately
 * kept out of the navbar (e.g. external properties).
 */
export const FooterOnlyLinks: GlobalNavLink[] = [
	{
		label: 'HENI Gallery',
		href: GlobalRoutes.GalleryHome,
	},
];
